/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SyncResponseBody = {
  /**
   * The durable sync was started or already running.
   */
  accepted: boolean;
};

/** @internal */
export const SyncResponseBody$inboundSchema: z.ZodMiniType<
  SyncResponseBody,
  unknown
> = z.object({
  accepted: z.boolean(),
});

export function syncResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<SyncResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SyncResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SyncResponseBody' from JSON`,
  );
}
